// assets

import sidebarIcon1 from "../assets/images/Black.svg";
import sidebarIcon2 from "../assets/images/Black-1.svg";
import sidebarIcon4 from "../assets/images/Black-2.svg";
import sidebarIcon1Active from "../assets/images/White.svg";
import sidebarIcon2Active from "../assets/images/White-1.svg";
import sidebarIcon4Active from "../assets/images/White-2.svg";

export const roles = [
    {
      id: 1,
      name: "Wordsmith",
      text: "Hi, I am Wordsmith, your intelligent writing companion designed to elevate your content creation. Whether you are drafting reports, presentations, or composing professional emails, I am here to help you communicate with clarity, precision, and style.",
      icon: sidebarIcon1,
      title: "Professional writing assistant",
      activeIcon: sidebarIcon1Active,
    },
    {
      id: 2,
      name: "Agronomica",
      text: "Hi, I am Agronomica, your expert agricultural companion dedicated to answering questions about crop science, soil management, sustainable farming, and agricultural technologies. From soil health to crop optimisation, I am here to provide insights and support for you.",
      icon: sidebarIcon2,
      title: "Sustainable farming guide",
      activeIcon: sidebarIcon2Active,
    },
    {
      id: 3,
      name: "Regulatrix",
      text: "Hi, I am Regulatrix, your comprehensive regulatory companion for the agrochemical industry, designed to navigate the complex landscape of agricultural regulations and compliance standards. I provide expert guidance on regulatory requirements, safety protocols, environmental regulations, and compliance strategies to support your agricultural business legal and ethical operations.",
      icon: sidebarIcon4,
      title: "Agrochemical compliance advisor",
      activeIcon: sidebarIcon4Active,
    }
];
